import { DocumentEvents } from "./../helpers/document-events";
import { AppSettings } from "../../app-settings";
import { AppEvents } from "../../app-events";
import { prop } from "../../decorators/property";
import { BaseDocumentModel } from "../../desktop/models/base-document";
import { CaseRelationModel } from "../../desktop/models/case-relation";
import { LegislationRelationModel } from "../../desktop/models/legislation-relation";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { transient } from "aurelia-dependency-injection";
import { ResultModel } from "../../search/models/result";

@backboneModelProperties({
    urlRoot: `${AppSettings.DocumentApiUrlPrefix}categorydocument`,
    relations : [
        {
            type: Backbone.Many,
            key: "LeadingCases",
            relatedModel: ResultModel
        },
        {
            type: Backbone.Many,
            key: "RecentCases",
            relatedModel: ResultModel
        },
        {
            type: Backbone.Many,
            key: "ImportantLegislation",
            relatedModel: LegislationRelationModel
        }
    ],
    defaults: {
        Populated: false,
        Visible: false,
        Animated: false,
        Expired: false,
        Highlighting: false,
        LeadingCases: [],
        RecentCases: [],
        ImportantLegislation: []
    }
})
@transient()
export class CategoryDocumentModel extends BaseDocumentModel {

    @prop() public LeadingCases: Backbone.Collection<ResultModel>;
    @prop() public RecentCases: Backbone.Collection<ResultModel>;
    @prop() public ImportantLegislation: Backbone.Collection<any>;
    @prop() public JurisdictionsFilterCount: number;

    constructor(options?) {
        super(options);
        this.setupEventListeners();
    }

    public refresh() {
        return new Promise<any>((resolve, reject) => {
            this.fetch({
                headers: {
                    UserSettings : this.getUserSettings()
                },
                data: $.param({ type: this.Id }),
                success: (data?: any) => {
                    resolve(data);
                    this.set("Visible", true);
                    this.trigger(DocumentEvents.DocumentRefreshed);
                }
            });
        });
    }

    public loadFullText() {
        return new Promise((resolve: any) => {
            resolve();
        });
    }

    private setupEventListeners(): void {
        this.appEvents.on(AppEvents.JurisdictionsSaved, () => {
            this.refresh();
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/category-document.ts